import { setup } from "web/entrypoints/common/setup";

import "./baustein-homepage";
import "./css-homepage";
import components from "./react-homepage";

setup(components);
